import React from "react";
import { useNavigate } from "react-router-dom";
import { ButtonGhostV2, ButtonTertiaryV2 } from "oolib";

const GlobalSearchButton = ({ isSmallScreen }) => {
   const navigate = useNavigate();
   const handleOnClick = () => {
      navigate("/global-search");
   }

   const ButtonComp = isSmallScreen ? ButtonTertiaryV2 : ButtonGhostV2;

   return (
      <div style={{ position: "relative" }}>
         <ButtonComp
            icon="MagnifyingGlass"
            responsive
            iconSize={isSmallScreen ? 20 : 16}
            onClick={handleOnClick}
            style={{
               borderRadius: "3.7rem",
               padding: isSmallScreen ? "1.2rem" : "0.9rem",
               paddingLeft: isSmallScreen ? "1.2rem" : "1.4rem",
               paddingRight: isSmallScreen ? "1.2rem" : "1.4rem",
            }}
         />
      </div>
   );
}

export default GlobalSearchButton;